import { render, staticRenderFns } from "./UploadCWL.vue?vue&type=template&id=2be0f874&"
import script from "./UploadCWL.vue?vue&type=script&lang=js&"
export * from "./UploadCWL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports